import classNames from 'classnames';
import tiltedDon from './tiltedDon.png';

export type TiltedDProps = JSX.IntrinsicElements['img'];
export const TiltedDon = ({ className, ...props }: TiltedDProps) => (
  <img
    src={tiltedDon}
    className={classNames('icon', className)}
    alt="tilted don"
    width={125}
    height={125}
    {...props}
  />
);
